import Vue from 'vue'
import _ from 'lodash'

const defaultAttrs = {
  width: '700px',
  beforeConfirm(dialog, form, done) {
    done()
  },
  beforeCloseByCancel(done) {
    if (this.loading) {
      return this.$message.info('正在通信中...请稍后关闭')
    }
    if (this.$root.formEl && this.$root.formEl.formHasModified) {
      this.$confirm('确认关闭？未保存的修改可能丢失')
        .then(done)
        .catch(() => {})
    } else {
      done()
    }
  },
}
export const dialogItem = Vue.extend({
  name: 'DialogItem',
  props: {
    title: {},
    beforeConfirm: {
      type: Function
    },
    beforeCloseByCancel: {
      type: Function
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    btns: {
      type: Object,
      default: () => {
        return {
          negative: '取消',
          positive: '确认',
          other: []
        }
      }
    },
  },
  data() {
    return {
      visible: true,
      loading: false
    }
  },
  created() {
    this.vm = this
  },
  mounted() {
    window.addEventListener('hashchange', this.hide)
  },
  destroyed() {
    window.removeEventListener('hashchange', this.hide)
  },
  methods: {
    onClose() {
      this.$destroy()
      this.$el.remove()
    },
    visibleChange(val) {
      this.visible = val
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    hide() {
      this.visible = false
    },
    // beforeCloseByCancel(done) {
    //   if (this.loading) {
    //     return this.$message.info('正在通信中...请稍后关闭')
    //   }
    //   if (this.$root.formEl && this.$root.formEl.formHasModified) {
    //     this.$confirm('确认关闭？未保存的修改可能丢失')
    //       .then(done)
    //       .catch(() => {})
    //   } else {
    //     done()
    //   }
    // },
    handleNegativeClick() {
      this.beforeCloseByCancel(() => {
        this.visible = false
      })
    },
    handlePositiveClick() {
      this.beforeConfirm(this, this.$root.formEl, () => {
        this.visible = false
        this.$emit('confirm', this, this.$root.formEl)
      })
    },
    btnClick(btn) {
      return () => {
        btn.onClick(this.vm, this.$root.formEl, this.$root)
      }
    }
  },
  render() {
    let footer
    if (!this.hideFooter) { // 如果不需要隐藏底部
      footer = this.$slots.footer // 获取footer插槽里的内容
      if (!footer) {
        this.btns.other = this.btns.other || []
        const otherBth = this.btns.other.map((btn, index) => (
          <el-button
            key={index}
            type={btn.type}
            style={btn.style}
            on-click={this.btnClick(btn)}
          >
            {btn.name}
          </el-button>
        ))
        let negativeBtn
        let positiveBtn
        if (this.btns.negative) {
          negativeBtn = (
            <el-button
              loading={this.loading}
              on-click={this.handleNegativeClick}
            >{ this.btns.negative }
            </el-button>
          )
        }
        if (this.btns.positive) {
          positiveBtn = (
            <el-button
              loading={this.loading}
              type="primary"
              on-click={this.handlePositiveClick}
            >{ this.btns.positive }
            </el-button>
          )
        }
        footer = (
          <div slot="footer">
            {otherBth}
            {negativeBtn}
            {positiveBtn}
          </div>
        )
      }
    }

    return (
      <el-dialog
        title={this.title}
        beforeClose={this.beforeCloseByCancel}
        visible={this.visible}
        appendToBody={true}
        {...{ attrs: this.$attrs }}
        {...{
          on: {
            'update:visible': this.visibleChange,
            close: this.onClose
          }
        }}
      >
        {this.$slots.default}
        {footer}
      </el-dialog>
    )
  }
})
// title: 弹窗的标题
// customAttrs: 需要传递给弹窗或者子组件的props
// dialogContent: 弹窗中需要渲染的子组件
export default (title = '对话框', customAttrs = {}, dialogContent = {}) => {
  const tempDom = document.createElement('div')
  document.body.appendChild(tempDom)
  // 若无需传 customAttrs 的话, 第二个参数可以直接写 dialogContent
  if (customAttrs.render) {
    dialogContent = customAttrs
    customAttrs = {}
  }

  customAttrs = { ...defaultAttrs, ...customAttrs }
  customAttrs.title = title

  if (customAttrs.status === '2') {
    customAttrs.btns = { negative: '关闭' }
  }
  return new Promise((resolve, reject) => {
    const baseDialog = new Vue({
      name: 'BaseDialog',
      components: {
        dialogItem,
      },
      created() {
        this.formEl = {}
      },
      data: function() {
        return {}
      },
      render(h) {
        return h(
          'dialog-item',
          {
            attrs: _.cloneDeep(customAttrs),
            ref: 'dialog',
            on: {
              confirm(dialog, content) {
                resolve({ dialog, content })
              }
            }
          },
          [
            h(dialogContent, {
              props: _.cloneDeep(customAttrs),
              ref: 'dialog-content'
            }),
          ]
        )
      },
      mounted() {
        if (customAttrs.mounted) {
          customAttrs.mounted(baseDialog)
        }
        // resolve(this)
        this.$nextTick(() => {
          this.formEl = this.$refs['dialog-content']
          this.formEl.$_dialog = this.$refs.dialog
        })
      }
    })
    baseDialog.$mount(tempDom)
  })
}
